import type { ApiResponse } from '../types';
import routes from '@/config/routes';
import { v3Get } from '@/api/axios.instance.V3';

const getGigCountryList = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.gigAdmin.country.get}${gigId}/list`);
const getGigProvinceList = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.gigAdmin.province.get}${gigId}?d=true&c=provinceId`);

export const gigCountryProvinceApi = {
  getGigCountryList,
  getGigProvinceList,
};
